import React, { useEffect } from "react";
import { Button, Table, Card, Switch, Modal, Form, Input, Space, Tooltip } from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModel } from "../../../models";
import SupplierModel from "./SupplierModel"
import { formatNum, ENV } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";



const TableHeader = () => {
    const [{ ModelVisible, ModelParams, selectedAccount }, { setModelVisible, setModelParams }] = useModel('supplierBill')

    const onDetail = () => {
        // console.log(ModelParams)
        setModelVisible(!ModelVisible)
        setModelParams({
            title: "账户调额",
            Visible: !ModelParams.Visible,
            type: "tiaoer"
        })
    }
    const onPay = () => {
        setModelVisible(!ModelVisible)
        setModelParams({
            title: "账户充值",
            Visible: !ModelParams.Visible,
            type: "chozhi"
        })
    }
    const accounts = () => {
        setModelVisible(!ModelVisible)
        setModelParams({
            title: "账户转账",
            Visible: !ModelParams.Visible,
            type: "zhuanzhang"
        })
    }

    return (
        <div>
            <div style={{ margin: "15px 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.ACC_S_ADI}>
                        <Tooltip placement="topLeft" title="调整额度只能账户类型为授信用户，才可以调整额度">
                            <Button className="margin-left-8" onClick={onDetail}
                                disabled={(selectedAccount && selectedAccount.accountType === "009001" ? false : true)}>调额</Button>
                        </Tooltip>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.ACC_S_CHARG}>
                        <Button type="primary" className="margin-left-8" disabled={!!!selectedAccount}
                            onClick={onPay}>充值</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.ACC_S_TRANS}>
                        <Button type="primary" className="margin-left-8" onClick={accounts}>转账</Button>
                    </YhAuth>
                </div>
            </div>
        </div>
    )
}

export default function () {
    const [
        { accountList, tabsKey, selectedSupplierBill, selectedSupplierRowKeysBill, selectedAccount, selectedAccountRowKeys },
        {
            loadSupplierAccountList, setSelectedAccount, setSelectedAccountRowKeys,
            setAdjustModelVisible, setFillModelVisible, setTransferModelVisible,
            enableOrDisableAccount
        }
    ] = useModel("supplierBill")
    const [{ accountTypeDict }, { getAccountTypeDict }] = useModel("cmDict");

    useEffect(() => {
        loadSupplierAccountList({ showMsg: false, data: selectedSupplierBill ? selectedSupplierBill.id : null })
        getAccountTypeDict()
    }, [selectedSupplierBill, tabsKey]);

    const columns = [
        {
            title: '账户编号',
            dataIndex: 'accountCode',
        },
        {
            title: '账户类型',
            dataIndex: 'accountType',
            render: (text, record) => {
                return (
                    <span>
                        {
                            accountTypeDict.map((item) => {
                                if (item.key === text) {
                                    return item.label
                                }
                            })
                        }
                    </span>
                )
            }
        },
        {
            title: '授信额度',
            dataIndex: 'creditLine',
            render: text => formatNum(text)
        },
        {
            title: '已用授信额度',
            dataIndex: 'usedCreditLine',
        },
        {
            title: '可用额度',
            dataIndex: 'availableCredit',
        },
        {
            title: '剩余金额',
            dataIndex: 'remainingAmount',
        },
        {
            title: '账户状态',
            key: 'accountStatus',
            dataIndex: 'accountStatus',
            render: (text, record) => (
                <Space size="middle" onClick={e => e.stopPropagation()}>
                    <Switch
                        checked={record.accountStatus === 0}
                        onChange={(checked) => {
                            onDisabled(record, checked);
                        }}
                        size="small" />
                </Space>
            ),
        },
        {
            title: '备注',
            dataIndex: 'remarks',
        },
    ];

    const onDisabled = (record, checked) => {
        let { accountCode, id } = record
        let accountStatus = checked ? 0 : 1
        enableOrDisableAccount({ showMsg: true, data: { id, accountStatus } })
    }
    const onChangSwitch = (checked, event) => {
        // let { accountCode, id } = record
        // let accountStatus = checked ? 0 : 1
        // enableOrDisableAccount({ showMsg: true, data: { id, accountStatus } })
    }
    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={accountList}
                bordered
                pagination={false}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (record.accountStatus === 1) {
                                setSelectedAccount(null);
                                setSelectedAccountRowKeys([]);
                            } else {
                                if (selectedAccount && selectedAccount.key === record.key) {
                                    setSelectedAccount(null);
                                    setSelectedAccountRowKeys([]);
                                } else {
                                    setSelectedAccount(record);
                                    setSelectedAccountRowKeys([record.key]);
                                }
                            }

                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedAccount(selectedRows[0]);
                        setSelectedAccountRowKeys(selectedRowKeys);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.accountStatus === 1,
                        name: record.name,
                    }),
                    selectedRowKeys: selectedAccountRowKeys
                }}
                scroll={{ x: 'max-content' }}
            />
            <SupplierModel />
        </>
    );
}